import { Formik, Form, FieldArray, Field, ErrorMessage } from "formik";
import { useHistory, NavLink } from "react-router-dom";
import * as Yup from "yup";
import "./StudentForm.scss";
import { useEffect, useState } from "react";

import Input from "./Inputs/Input";
import { images } from "../../constants";

import Toggle from "../generalComponents/Toggle";
import {
  getDate4mothsAfter,
  getDateAfter,
  getDateBefore,
} from "../../helper/dateConvertor";
import Select from "./Inputs/Select";
import { countryCodes } from "../../helper/countryCodes";
import { eduSystemAu } from "../../helper/eduSystemAu";
import PhoneInput from "./Inputs/PhoneInput";
import { eduSystemG } from "../../helper/eduSystemG";
import { createStudent } from "../../actions/student";
import { useDispatch, useSelector } from "react-redux";
import AlertPopUp from "../generalComponents/AlertPopUp";
import LoaderDots from "../generalComponents/LoaderDots";
import { gender } from "../../helper/gender";

const StudentForm = () => {
  const [formValues] = useState(null);

  const [state, setState] = useState({
    // volver esto un custom hook
    isOnShore: true,
  });

  const { msgAlert } = useSelector((state) => state.alert);
  const { laoding } = useSelector((state) => state.ui);

  const dispatch = useDispatch();

  const history = useHistory();
  useEffect(() => {
    // if (studentforediting) {
    //   setValues(studentforediting);
    // }
    // if (state.isOnShore) {
    //   console.log("Student is in Au");
    // } else {
    //   console.log("Student is not in Au");
    // }
    //eslint-disable-next-line
  }, [state]);

  const fourMonthAfter = getDate4mothsAfter();

  const initialValues = {
    status: "",
    name: "",
    middlename: "",
    lastname: "",
    gender: "",
    nationality: "",
    maritalstatus: "",
    phone: { dial_code: "", number: "" },
    email: "",
    // password: "",
    currentlocation: "",
    comment: "",
    //onshore
    arriveddate: "",
    visatype: "",
    visaexpiration: "",
    visatimesrenewal: "",
    coursescompleted: [],
    currentcourse: "",
    finishingcurrentcourse: "",
    curseofinterestmost: "",
    highestonshorelevelacademic: "",
    medicalexams: "",
    // //offshore
    planningdate: "",
    coursesofinterest: [],
    coursesfinished: [], //{course:'', dateinitial:'', datefinished:''}
    academiclevel: "",
    // studiescompleteddate: "",
  };

  const dateSixAfter = getDateAfter();
  const dateSixBefore = getDateBefore();

  const studentSchema = Yup.object().shape({
    name: Yup.string().required("First Name required"),
    middlename: Yup.string(),
    lastname: Yup.string().required("Last Name required"),
    gender: Yup.string().required("Gender required"),
    nationality: Yup.string().required("Nationality required"),
    maritalstatus: Yup.string().required("Marital Staus required"),
    phone: Yup.object().shape({
      dial_code: Yup.string().required("Country code required"),
      number: Yup.number().required("Number Required"),
    }),
    email: Yup.string().email().required("Email required"),
    // password: Yup.string(),
    currentlocation: Yup.string().required("Current Location required"),
    comment: Yup.string(),
    //onshore
    arriveddate: Yup.date().max(new Date(), "Date must be earlier"),
    visatype: Yup.string(),
    visaexpiration: Yup.date()
      .max(dateSixAfter, "Date must be earlier")
      .min(dateSixBefore, "Date must be later"),
    visatimesrenewal: Yup.number().min(0, "Invalid number"),
    coursescompleted: Yup.array(),
    currentcourse: Yup.string(),
    finishingcurrentcourse: Yup.date()
      .max(dateSixAfter, "Date must be earlier")
      .min(dateSixBefore, "Date must be later"),
    curseofinterestmost: Yup.string(),
    highestonshorelevelacademic: Yup.string(),
    medicalexams: Yup.date()
      .max(dateSixAfter, "Date must be earlier")
      .min(dateSixBefore, "Date must be later"),
    // //offshore
    planningdate: Yup.date().min(
      fourMonthAfter,
      "Select a date four months after today"
    ).max(dateSixAfter, "Date must be earlier"),
    coursesofinterest: Yup.array(),
    coursesfinished: Yup.array().of(
      Yup.object().shape({
        dateinitial: Yup.date()
          .max(dateSixAfter, "Date must be earlier")
          .min(dateSixBefore, "Date must be later"),
        datefinished: Yup.date()
          .required("Date required")
          .max(dateSixAfter, "Date must be earlier")
          .min(dateSixBefore, "Date must be later"),
      })
    ),
    academiclevel: Yup.string(),
    // studiescompleteddate: Yup.string(),
  });

  const handleClick = () => {
    setState({
      isOnShore: !state.isOnShore,
    });
  };

  const handleFormikSubmit = (values, actions) => {
    if (state.isOnShore) {
      values.status = "Onshore";
    } else {
      values.status = "Offshore";
    }

    dispatch(createStudent(values));

    setTimeout(() => {
      history.push("/creator/students");
    }, 1000);
  };

  return (
    <div className="app__studentForm">
      <div>
        <div className="new-student-form__heading">
          <div className="student-form__heading--title">
            <h1 className="title-22-bold-grey">Add a new Student</h1>
            <NavLink to={`/creator/students`}>
              <button className="btn-primary">Go Back</button>
            </NavLink>
          </div>
          <p className="text-20-grey paragraph">
            This form allows you to create a new Student.
          </p>
        </div>

        <Formik
          initialValues={formValues || initialValues}
          validationSchema={studentSchema}
          onSubmit={handleFormikSubmit}
          enableReinitialize
        >
          {({ values }) => {
            return (
              <div className="student-form__wrapper">
                <div className="studet-form__container">
                  <Form>
                    <Input name="name" label="What is your name?" />
                    <Input name="middlename" label="What is your middlename?" />
                    <Input name="lastname" label="What is your lastname?" />
                    <Select
                      name="gender"
                      label={`Gender`}
                      options={gender}
                      isModal={false}
                    />
                    <Select
                      name="nationality"
                      label={`Nationality`}
                      options={countryCodes}
                      isModal={false}
                    />

                    <Input
                      name="maritalstatus"
                      label="Happily Married / Single / De Facto?"
                    />

                    <PhoneInput name={values.phone} label="Phone" />

                    <Input name="email" label="Share your email with us" />

                    <Input name="currentlocation" label="Current location" />
                    <Input name="comment" label="Comments?" />

                    <div className="form-container--toggle">
                      <Toggle state={state} handleClick={handleClick} />
                    </div>

                    <div>
                      {state.isOnShore ? (
                        <div className="onShore">
                          <Input
                            name="arriveddate"
                            label="When did you arrive to Australia?"
                            type="date"
                          />
                          <Input
                            name="visatype"
                            label="What kind of visa do you have?"
                          />
                          <Input
                            name="visaexpiration"
                            label="When expire your visa?"
                            type="date"
                          />
                          <Input
                            name="visatimesrenewal"
                            label="How many times have you renewed your student visa?"
                            type="number"
                          />

                          {/* ARRAY */}

                          <div className="section__input-array">
                            <FieldArray name="coursescompleted">
                              {({ remove, push }) => (
                                <div className="field-array">
                                  <div className="field-array__heading">
                                    <label className="field-array__heading--label title-gray-black-18 label-tag">
                                      Courses Completed:
                                    </label>

                                    <button
                                      className="field-array__heading--add-btn btn-primary"
                                      type="button"
                                      onClick={() => push("")}
                                    >
                                      + add
                                    </button>
                                  </div>

                                  {values.coursescompleted.length > 0 &&
                                    values.coursescompleted.map((cp, index) => (
                                      <div
                                        className="field-array__input"
                                        key={index}
                                      >
                                        <Field
                                          className="field-array__input--item"
                                          name={`coursescompleted.${index}`}
                                        />
                                        <button
                                          className="field-array__input--remove-btn"
                                          type="button"
                                          onClick={() => remove(index)}
                                        >
                                          <img src={images.IconRemove} alt="" />
                                        </button>
                                      </div>
                                    ))}
                                </div>
                              )}
                            </FieldArray>
                            <div className="error-alert">
                              <ErrorMessage name="coursescompleted" />
                            </div>
                          </div>

                          {/* ARRAY */}

                          <Input
                            name="currentcourse"
                            label="Which is your current course?"
                          />
                          <Input
                            type="date"
                            name="finishingcurrentcourse"
                            label="When is your current course finishing?"
                          />
                          <Input
                            name="curseofinterestmost"
                            label="What course interest you the most?"
                          />

                          <Select
                            name="highestonshorelevelacademic"
                            label={`Highest academic level achieved?`}
                            options={eduSystemAu}
                            isModal={false}
                          />

                          <Input
                            name="medicalexams"
                            label="When was the last time you had arrange medical examinations for visa purposes?"
                            type="date"
                          />
                        </div>
                      ) : (
                        <div className="offShore">
                          <Input
                            name="planningdate"
                            label="When are you planning to come?"
                            type="date"
                          />

                          <div className="section__input-array ">
                            <FieldArray name="coursesofinterest">
                              {({ remove, push }) => (
                                <div className="field-array">
                                  <div className="field-array__heading">
                                    <label className="field-array__heading--label title-gray-black-18  label-tag">
                                      Courses of Interest:
                                    </label>

                                    <button
                                      className="field-array__heading--add-btn btn-primary"
                                      type="button"
                                      onClick={() => push("")}
                                    >
                                      + add
                                    </button>
                                  </div>

                                  {values.coursesofinterest.length > 0 &&
                                    values.coursesofinterest.map(
                                      (cp, index) => (
                                        <div
                                          className="field-array__input"
                                          key={index}
                                        >
                                          <Field
                                            className="field-array__input--item"
                                            name={`coursesofinterest.${index}`}
                                          />
                                          <button
                                            type="button"
                                            className="field-array__input--remove-btn"
                                            onClick={() => remove(index)}
                                          >
                                            <img
                                              src={images.IconRemove}
                                              alt=""
                                            />
                                          </button>
                                        </div>
                                      )
                                    )}
                                </div>
                              )}
                            </FieldArray>
                            <div style={{ color: "red" }}>
                              <ErrorMessage name="coursesofinterest" />
                            </div>
                          </div>
                          {/* WORKING ON HERE */}
                          <div className="COURSES-FINISHED section__input-array ">
                            <FieldArray name="coursesfinished">
                              {({ remove, push }) => (
                                <div className="field-array">
                                  <div className="field-array__heading">
                                    <label
                                      htmlFor=""
                                      className="field-array__heading--label  title-gray-black-18"
                                    >
                                      Courses Finished and in progress:
                                    </label>
                                    <button
                                      className="field-array__heading--add-btn btn-primary"
                                      type="button"
                                      onClick={() =>
                                        push({
                                          course: "",
                                          dateinitial: "",
                                          datefinished: "",
                                        })
                                      }
                                    >
                                      + add
                                    </button>
                                  </div>
                                  {values.coursesfinished.length > 0 &&
                                    values.coursesfinished.map((ci, index) => (
                                      <div
                                        key={index}
                                        className="ESTE ES EL GRUPO GRANDE field-array__input-group"
                                      >
                                        <div className="ESTE ES CADA INPUT(ESPACIO) field-array__input-group--item">
                                          <label
                                            htmlFor=""
                                            className=" title-gray-bold-16"
                                          >
                                            Course
                                          </label>
                                          <Field
                                            className="field-array__input--item"
                                            name={`coursesfinished.${index}.course`}
                                          />
                                        </div>

                                        <div className="ESTE ES CADA INPUT(ESPACIO) field-array__input-group--item">
                                          <label
                                            htmlFor=""
                                            className=" title-gray-bold-16"
                                          >
                                            Initial date
                                          </label>
                                          <Field
                                            type="date"
                                            className="field-array__input--item"
                                            name={`coursesfinished.${index}.dateinitial`}
                                          />
                                          <div className="error-message-form">
                                            <ErrorMessage
                                              name={`coursesfinished.${index}.dateinitial`}
                                            />
                                          </div>
                                        </div>

                                        <div className="ESTE ES CADA INPUT(ESPACIO) field-array__input-group--item">
                                          <label
                                            htmlFor=""
                                            className=" title-gray-bold-16"
                                          >
                                            Finish date
                                          </label>
                                          <Field
                                            type="date"
                                            className="field-array__input--item"
                                            name={`coursesfinished.${index}.datefinished`}
                                          />
                                          <div className="error-message-form">
                                            <ErrorMessage
                                              name={`coursesfinished.${index}.datefinished`}
                                            />
                                          </div>
                                        </div>

                                        <button
                                          type="button"
                                          className="btn-remove"
                                          onClick={() => remove(index)}
                                        >
                                          remove
                                        </button>
                                      </div>
                                    ))}
                                </div>
                              )}
                            </FieldArray>
                          </div>

                          {/* WORKING UP TO HERE */}

                          <Select
                            name="academiclevel"
                            label={`Highest academic level achieved?`}
                            options={eduSystemG}
                            isModal={false}
                          />
                          {/* <Input
                            name="studiescompleteddate"
                            label="When did you complete it?"
                            type="date"
                          /> */}
                        </div>
                      )}
                    </div>

                    <div className="form-container__button-send">
                      {laoding ? (
                        <LoaderDots />
                      ) : (
                        <button className="btn btn-save" type="submit">
                          Add Student
                        </button>
                      )}
                    </div>
                  </Form>
                </div>

                <div>
                  {msgAlert && (
                    <AlertPopUp msg={`${msgAlert.msg}`} type={msgAlert.type} />
                  )}
                </div>
              </div>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default StudentForm;
